const initialState = {
    pending: false,
    notifications: [],
    error: null
};

const notificationsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_NOTIFICATIONS_PENDING':
            return {
                ...state,
                pending: true
            };
        case 'GET_NOTIFICATIONS_SUCCESS':
            return {
                ...state,
                pending: false,
                notifications: action.notifications
            };
        case 'GET_NOTIFICATIONS_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        default:
            return state;
    }
};

export default notificationsReducer;